export const auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || "your-domain.auth0.com",
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID || "your-client-id",
  audience:
    process.env.REACT_APP_AUTH0_AUDIENCE || "https://api.greek-cloze.com",
  redirectUri: window.location.origin,
  scope: "openid profile email",
};

// Validate Auth0 configuration
export const validateAuth0Config = () => {
  const { domain, clientId } = auth0Config;

  console.log(domain);
  console.log(clientId);

  if (domain === "your-domain.auth0.com" || clientId === "your-client-id") {
    console.error("Auth0 configuration is not properly set up!");
    console.error("Please:");
    console.error("1. Create a .env file in the frontend directory");
    console.error("2. Add your Auth0 credentials:");
    console.error("   REACT_APP_AUTH0_DOMAIN=your-actual-domain.auth0.com");
    console.error("   REACT_APP_AUTH0_CLIENT_ID=your-actual-client-id");
    console.error("   REACT_APP_AUTH0_AUDIENCE=https://api.greek-cloze.com");
    console.error("3. Get these values from your Auth0 Dashboard");
    return false;
  }

  return true;
};
